import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SanitizeHtmlPipe } from 'shared/util-common';

import { DIALOG_DATA } from '@treetop/shared/model';

import { BannerComponent } from '../../banner/banner.component';
import { ButtonDirective } from '../../button/button.directive';
import { DialogRef } from '../dialog-ref';
import { DialogModule } from '../dialog.module';

export interface ConfirmationDialogItem {
  text: string;
  textParams?: Record<string, string>;
  warningText?: string;
  confirmButton: string;
  cancelButton?: string;
}

@Component({
  selector: 'common-confirmation-dialog-new',
  standalone: true,
  imports: [TranslocoModule, DialogModule, SanitizeHtmlPipe, BannerComponent, ButtonDirective],
  templateUrl: './confirmation-dialog-new.component.html',
  styleUrls: ['./confirmation-dialog-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogNewComponent implements OnInit {
  protected confirmationDialogData = inject<ConfirmationDialogItem>(DIALOG_DATA);
  private dialogRef = inject<DialogRef<boolean>>(DialogRef);

  protected cancelButtonText: string;

  public ngOnInit(): void {
    this.cancelButtonText = this.confirmationDialogData.cancelButton;
  }

  public handleCancel() {
    this.dialogRef.close(false);
  }

  public handleConfirm() {
    this.dialogRef.close(true);
  }
}
